<template>
	<div>
		<card tag="section" layout="metric" v-if="metrics?.length > 0 || compare?.length > 0">
			<template #top>
				<chart-legend show-current :show-compare="compare.length > 0" show-dashed></chart-legend>
			</template>
			<template #default>
				<metric-box metric="totalBillings" :results="metrics" :compare="compare" :samples="samples">
					Total Billings
				</metric-box>
				<metric-box metric="executive" :results="metrics" :compare="compare" :samples="samples">
					Executive Search
				</metric-box>
				<metric-box metric="consulting" :results="metrics" :compare="compare" :samples="samples">
					Leadership Consulting
				</metric-box>
				<metric-box metric="im" :results="metrics" :compare="compare" :samples="samples">
					Interim Management
				</metric-box>
				<metric-box metric="teamingValue" :results="metrics" :compare="compare" :samples="samples">
					Teaming Value
				</metric-box>
				<metric-box
					metric="teamingRevenue"
					:results="metrics"
					:compare="compare"
					:samples="samples">
					Teaming Revenue
				</metric-box>
				<metric-box
					metric="filledJobValue"
					:results="metrics"
					:compare="compare"
					:samples="samples">
					Average Filled Job Value
				</metric-box>
			</template>
		</card>
		<card v-if="details && details.partners" layout="metric" metric-size="sm" class="mt-5">
			<metric-row
				metric="partnerChange"
				:results="[{ partnerChange: details.partners.currentCount }]"
				:compare="[{ partnerChange: details.partners.currentCountStart }]"
				v-if="details.partners">
				Partner Change
			</metric-row>
			<metric-row
				metric="partner"
				:results="[{ partner: details.partners.currentCount }]"
				:compare="[{ partner: details.partners.previousCount }]"
				v-if="details.partners">
				<div class="metricWithComparison">
					Partners -
					<span class="twelveMonthComparison">12 month comparison</span>
				</div>
			</metric-row>
			<metric-row
				metric="researcher"
				:results="[{ researcher: details.researchers.current }]"
				:compare="[{ researcher: details.researchers.previous }]"
				v-if="details.researchers">
				<div class="metricWithComparison">
					Researchers -
					<span class="twelveMonthComparison">12 month comparison</span>
				</div>
			</metric-row>
			<metric-row
				metric="admin"
				:results="[{ admin: details.administration.current }]"
				:compare="[{ admin: details.administration.previous }]"
				v-if="details.administration">
				<div class="metricWithComparison">
					Administration -
					<span class="twelveMonthComparison">12 month comparison</span>
				</div>
			</metric-row>
		</card>
		<card layout="metric" metric-size="sm" class="mt-5" v-if="metrics?.length > 0">
			<template v-slot:default>
				<metric-row metric="assignmentsTaken" :results="metrics" :compare="compare">
					Assignments Taken
				</metric-row>
				<metric-row metric="teamingTaken" :results="metrics" :compare="compare">
					Teaming Taken
				</metric-row>
				<metric-row metric="assignmentsFilled" :results="metrics" :compare="compare">
					Assignments Filled
				</metric-row>
				<metric-row metric="teamingFilled" :results="metrics" :compare="compare">
					Teaming Filled
				</metric-row>
				<metric-row metric="timeToFill" :results="metrics" :compare="compare">
					Time to Fill
				</metric-row>
			</template>
		</card>
	</div>
</template>
<script>
	import { ref, onMounted, inject, watch, nextTick } from "vue";
	import metricBox from "./metricBoxFacade.vue";
	import metricRow from "@/components/webComponents/metricRow.vue";
	import { legend } from "@/components/charts";

	export default {
		components: {
			metricBox,
			metricRow,
			chartLegend: legend
		},
		props: {
			metrics: {
				type: Array,
				default: () => {
					return [];
				}
			},
			compare: {
				type: Array,
				default: () => {
					return [];
				}
			},
			details: {
				type: Object,
				default: () => {
					return {};
				}
			},
			samples: {
				type: Object,
				default: () => {
					return {};
				}
			},
			teamingValues: {
				type: Array,
				default: () => {
					return [];
				}
			}
		},
		setup(props, context) {
			return {};
		}
	};
</script>